var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.218734 14.5522L8.15006 0.815728C8.29326 0.567714 8.49922 0.361763 8.74723 0.218573C8.99525 0.0753831 9.27659 0 9.56298 0C9.84936 0 10.1307 0.0753831 10.3787 0.218573C10.6267 0.361763 10.8327 0.567714 10.9759 0.815728L18.9064 14.5522C19.0496 14.8003 19.1251 15.0817 19.1251 15.3681C19.1251 15.6546 19.0497 15.936 18.9065 16.1841C18.7633 16.4322 18.5573 16.6382 18.3092 16.7814C18.0611 16.9246 17.7797 17 17.4932 17H1.63186C1.3454 17 1.06398 16.9246 0.815899 16.7814C0.567813 16.6382 0.361804 16.4322 0.218583 16.1841C0.0753608 15.936 -2.64949e-05 15.6546 6.98506e-09 15.3681C2.65228e-05 15.0817 0.0754659 14.8003 0.218734 14.5522ZM9.45959 5.05235H9.66648C10.1758 5.05235 10.5888 5.46527 10.5888 5.97464V10.383C10.5888 10.8924 10.1758 11.3053 9.66648 11.3053H9.45959C8.95022 11.3053 8.53729 10.8924 8.53729 10.383V5.97464C8.53729 5.46527 8.95022 5.05235 9.45959 5.05235ZM10.5888 13.7759C10.5888 14.3424 10.1295 14.8017 9.56303 14.8017C8.99653 14.8017 8.53729 14.3424 8.53729 13.7759C8.53729 13.2094 8.99653 12.7502 9.56303 12.7502C10.1295 12.7502 10.5888 13.2094 10.5888 13.7759Z",
    fill: "#A91B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.51da2b4c54116a27f185bbbd32a78edb.svg";
export { ForwardRef as ReactComponent };